export const encodeUnpaddedBase64 = (bytes) => {
    let binary = "";

    for (const byte of new Uint8Array(bytes)) {
        binary += String.fromCharCode(byte);
    }

    return btoa(binary).replace(/=+$/, "");
};
